module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/petition/petition-grid/petition-grid.component.css
// module id = ./src/app/petition/petition-grid/petition-grid.component.css
// module chunks = main